
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import TariffList from './List';
import TariffAddBase from './AddBase';
import TariffAddIndividual from './AddIndividual';
import TariffDetailBase from './DetailBase';
import TariffDetailIndividual from './DetailIndividual';


export default class TariffRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/tariff/add_base" exact component={TariffAddBase} />
        <Route path="/tariff/add_base/:id" exact component={TariffAddBase} />
        <Route path="/tariff/add_individual" exact component={TariffAddIndividual} />
        <Route path="/tariff/add_individual/:id" exact component={TariffAddIndividual} />

        <Route path="/tariff/base/:id" exact component={TariffDetailBase} />
        <Route path="/tariff/individual/:id" exact component={TariffDetailIndividual} />
        <Route path="/tariff" exact component={TariffList} />
      </Switch>
    );
  }
}
